<template>
  <v-container align-start id="previewjob">
    <div class="section_inner">
      <v-layout column>
        <v-flex>
          <v-layout wrap class="justify-space-between">
            <v-flex xl10 lg10 class="jobs-row">
              <div v-if="!error">
                <JobItem
                  :job-details="jobData"
                  class="job-item"
                  :isSingleJob="true"
                  :class="[isHotJob ? 'mt-7 ' : '']"
                  :previewjob="true"
                  :recomended-job="jobData.JobInfo.IsRecommender"
                />

                <p class="display-26 text-center mt-4">
                  <span>קישור למשרה באתר</span>
                  <a
                    :href="jobUrlPage"
                    title="קישור למשרה באתר"
                    class="ltr d-inline-block"
                  >
                    {{ jobUrlPage }}
                  </a>
                </p>
              </div>

              <h3 class="text-center red--text mt-4" v-else>
                {{ expiredJobMessage }}
              </h3>
            </v-flex>

            <v-flex sm2 class="ads-row">
              <v-layout colomun wrap>
                <v-flex>
                  <SectionCompaniesInnerPages :page="'servicesPage'" />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import JobItem from '@/components/Jobs_List/Jobs_On_Drushim/Job_Item/JobItem';
import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages';

import { JOB_PREVIEW } from '@/lib/api.js';

export default {
  layout: 'innerPage',
  name: 'servicesPage',
  components: {
    JobItem,
    SectionCompaniesInnerPages,
  },

  data() {
    return {
      error: false,
    };
  },

  async asyncData({ error, route, $axios }) {
    const { jobcode } = route.query;

    try {
      let { data } = await $axios.get(`${JOB_PREVIEW}?jobcode=${jobcode}`);

      if (data.Job == null) {
        return {
          expiredJobMessage: data.Message.KeyValue.Value,
          error: true,
        };
      }
      if (data.IsError) {
        throw data.Errors;
      }

      return {
        error: data.IsError,
        jobData: data.Job,
        isHotJob: data.Job.JobInfo.Hot,
        jobUrlPage: data.Message.Link,
      };
    } catch (e) {
      return error({
        statusCode: 404,
        path: route.fullPath,
        message: 'preview job page error: ' + e,
      });
    }
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.theme--light.v-list {
  background: transparent;
}

.jobs-row {
  max-width: 934px;
}

.ads-row {
  max-width: 300px;
}

.job-item {
  border-right: 9px solid #f2f0ef;
}

.job-item.preferred {
  border-right: 9px solid $primary;
}

.filter-btn {
  margin: 0;
  margin-left: 14px;
  border: solid 1px #e3e4e6;
  background-color: rgba(46, 40, 36, 0);
  display: inline-flex;
  align-items: center;
  padding: 5px 10px 5px 10px;
  letter-spacing: -1px;
  font-size: 12px;
}

.filter-by-text {
  display: none;
}

.filter-icon {
  display: inline-block;
  margin-left: 6px !important;
}

.filter-icon:before {
  color: #000;
}

.filter-btn:hover {
  border: 1px solid #000;
}

h3 {
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: -0.9px;
}

.aside-ad {
  background: #3e4a54;
  text-align: center;
}

@media only screen and (min-width: 700px) {
  .filter-by-text {
    display: block;
  }

  .filter-btn {
    margin: 0;
    height: 50px;
    width: 200px;
    margin-left: 14px;
    border: solid 1px #e3e4e6;
    background-color: rgba(46, 40, 36, 0);
    display: inline-flex;
    align-items: center;
    padding: 5px 10px 5px 10px;
    letter-spacing: -1px;
    font-size: 24px;
  }
}

@media screen and (max-width: 1280px) {
  .jobs-row {
    max-width: 100%;
  }

  .ads-row {
    display: none;
  }
}
</style>
